/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import { AirQualityWrapper } from './airQualityWrapper.tsx';

const props = [];

export const AirQualityWrapperDirective = reactDirective => reactDirective(AirQualityWrapper, props);
AirQualityWrapperDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('airQualityWrapper', AirQualityWrapperDirective);
